import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { linkToGZ } from '@/utils';

import { useJWT } from '@/hooks/useJWT.hook';
import { useLocalStorage } from '@/hooks/useLocalStorage.hook';

import LangSwitcher from '@/components/LangSwitcher';

import { RoutesEnum } from '@/enums/routes.enum';
import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { tKeys } from '@/i18n/resourses';

import { List, StyledLink } from './SidebarBottom.styles';

export const LogoutButton = styled('button')({
  border: '2px solid #1CFF47',
  borderRadius: '6px',
  fontSize: '14px',
  fontWeight: '700',
  color: '#FFFFFF',
  fontFamily: "'Montserrat', sans-serif",
  width: '100%',
  height: '48px',
  textTransform: 'uppercase',
  background: 'transparent',
  outline: 'none',
});

const SidebarBottom = () => {
  const { t } = useTranslation();
  const { jwt, removeJWT } = useJWT();
  const { value: lang } = useLocalStorage<string>(StorageKeysEnum.i18nextLng);

  const links: Array<{ label: string; href: string }> = [
    {
      label: t(tKeys.rules),
      href: RoutesEnum.rules,
    },
    {
      label: t(tKeys.howToPlay),
      href: RoutesEnum.help,
    },
  ];

  const handleLogout = () => {
    removeJWT();
    window.location.assign(linkToGZ(lang));
  };

  return (
    <div style={{ position: 'relative' }}>
      <List>
        {links.map((item, id) => (
          <li key={id}>
            <StyledLink to={item.href}>{item.label}</StyledLink>
          </li>
        ))}
        <div style={{ width: '100px', margin: '0 auto' }}>
          <LangSwitcher />
        </div>
        {jwt && (
          <LogoutButton onClick={handleLogout}>{t(tKeys.logout)}</LogoutButton>
        )}
      </List>
    </div>
  );
};

export default SidebarBottom;
